export default __webpack_public_path__ + "static/media/step2.6d51719f.png";